import styles from "./SearchAutoSuggest.module.scss";
import { TextInput } from "@JohnLewisPartnership/jl-design-system/dist/components/text-input/TextInput";
import { SearchOutlined as Search32PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/SearchOutlined";
import DeviceList from "../DeviceList/DeviceList";
import { Device } from "../types";

type Props = {
  onInputChange: (e: { target: { value: string } }) => void;
  placeholder: string;
  searchString: string;
  searchResult: Device[];
  onSelectDevice: (deviceId: string) => void;
};

const SearchAutoSuggest = ({
  onInputChange,
  placeholder,
  searchString,
  searchResult,
  onSelectDevice,
}: Props) => {
  return (
    <div className={styles.autosuggest}>
      <p className={styles.visuallyHidden}>
        Results will be presented after the text input - after searching, please
        tab out of the input to start reading through them.
      </p>
      <div className={styles.autosuggest__inputWrapper}>
        <TextInput
          className={styles.autosuggest__input}
          labelText={placeholder}
          showLabel={true}
          id="searchDevice"
          name="searchDevice"
          onChange={onInputChange}
          disabled={false}
          value={searchString}
          data-cy="search-device-input-txt"
          autoComplete="off"
          maxLength={100}
          data-testid="search-device-input"
          data-cs-encrypt={true}
        />
        <Search32PxOutlinedIcon
          className={styles.autosuggest__searchIcon}
          size="large"
        />
      </div>
      <DeviceList
        searchResult={searchResult}
        totalResults={searchResult.length}
        showResultInfo
        onSelect={onSelectDevice}
      />
    </div>
  );
};

export default SearchAutoSuggest;
